import {
  DatePickerInput as MantineDatePickerInput,
  type DatePickerInputProps,
} from "@mantine/dates";
import { useCallback, useEffect, useRef } from "react";
import {
  type Control,
  type FieldValues,
  type Path,
  useController,
} from "react-hook-form";

const months = {
  Jan: "01",
  Feb: "02",
  Mar: "03",
  Apr: "04",
  May: "05",
  Jun: "06",
  Jul: "07",
  Aug: "08",
  Sep: "09",
  Oct: "10",
  Nov: "11",
  Dec: "12",
} as const;

interface Props<T extends FieldValues> extends DatePickerInputProps {
  name: Path<T>;
  control: Control<T>;
  additionalSetISODate?: (val: string) => void;
  placeholder?: string;
}

function DatePickerInput<T extends FieldValues>({
  name,
  control,
  additionalSetISODate,
  ...props
}: Props<T>) {
  const ref = useRef<HTMLButtonElement | null>(null);
  const { field } = useController({
    name,
    control,
  });

  const convertDate = useCallback(() => {
    if (!ref.current) return null;
    const parts = ref.current?.innerText.split(" ") ?? [];
    if (parts.length !== 3) return null;
    const date = `${parts[2]}-${months[parts[1] as keyof typeof months]}-${
      parts[0]
    }`;
    const iso = `${date}T00:00:00.000Z`;
    return iso;
  }, []);

  useEffect(() => {
    if (additionalSetISODate) {
      const date = convertDate();
      if (date) {
        additionalSetISODate(date);
      }
    }
  }, [additionalSetISODate, convertDate, field.value]);
  return (
    <MantineDatePickerInput
      {...field}
      {...props}
      ref={ref}
      dropdownType="modal"
      clearable
    />
  );
}

export default DatePickerInput;
